import { Service, signal } from '@angular/core';

@Service()
export class MainNavigationLock {
  private readonly lockedState = signal(false);
  readonly locked = this.lockedState.asReadonly();

  setLocked(isLocked: boolean): void {
    this.lockedState.set(isLocked);
  }
}
